import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {SolverData} from "#template/runtime-graph/nodes/solver/data"
import type {SolverObjectData} from "#template/runtime-graph/nodes/solver/object-data"
import type {SolverRelationData} from "#template/runtime-graph/nodes/solver/relation-data"
import type {SolverVariableData} from "#template/runtime-graph/nodes/solver/variable-data"

const TD = TypeDescriptors

const mergeSolverDataDescriptor = {
    input: TD.inlet(TD.Array(TD.Identity<SolverData>())),
    output: TD.outlet(TD.Identity<SolverData>()),
}

export class MergeSolverData implements NodeClassImpl<typeof mergeSolverDataDescriptor, typeof MergeSolverData> {
    static descriptor = mergeSolverDataDescriptor
    static uniqueName = "MergeSolverData"
    input!: Inlet<SolverData[]>
    output!: Outlet<SolverData>

    run() {
        if (this.input === NotReady) {
            this.output.emitIfChanged(NotReady)
            return
        }
        const objects: SolverObjectData[] = []
        const relations: SolverRelationData[] = []
        const variables: SolverVariableData[] = []
        for (const inp of this.input) {
            if (!inp) continue
            if (inp.objects) {
                for (const x of inp.objects) {
                    if (x) objects.push(x)
                }
            }
            if (inp.relations) {
                for (const x of inp.relations) {
                    if (x) relations.push(x)
                }
            }
            if (inp.variables) {
                for (const x of inp.variables) {
                    if (x) variables.push(x)
                }
            }
        }
        this.output.emitIfChanged({
            objects,
            relations,
            variables,
        })
    }
}
